var moment = require('moment')

export const distanceList = (activities) => {
    
    activities = Array.from(activities)
    var distance = activities.map(activity =>activity.distance)
    var dates = activities.map(activity =>activity.date)
    //console.log(tss,"lookhere")
    if (distance.length===0){
      //console.log(activities,"tssList is null?")
      return [[0,0,0,0],["1","2","3","4"]]
      
    }
    distance.push(0)
    dates.push(moment())
    return [distance,dates]
}



export const durationList = (activities) => {
    
  activities = Array.from(activities)
  var duration = activities.map(activity =>activity.duration)
  var dates = activities.map(activity =>activity.date)
  //console.log(tss,"lookhere")
  if (duration.length===0){
    //console.log(activities,"tssList is null?")
    return [[0,0,0,0],["1","2","3","4"]]
    
  }
  duration.push(0)
  dates.push(moment())
  return [duration,dates]
}

export const distanceSum = (activities) => {
    
  activities = Array.from(activities)

  const today = moment()
  const lastMonth = moment().subtract(1, 'month');
  const lastWeek = moment().subtract(1, 'week');
  const lastYear = moment().subtract(1, 'year');

  var distanceMonth = 0
  var distanceWeek = 0
  var distanceYear = 0

  for (var i=0;i<activities.length;i++){
    //
    if(lastMonth.isBefore(activities[i].date)){
      //console.log(activities[i].date,activities[i].distance)
      distanceMonth = distanceMonth + activities[i].distance
    }
    if(lastWeek.isBefore(activities[i].date)){
      //console.log(activities[i].date,activities[i].distance)
      distanceWeek = distanceWeek + activities[i].distance
    }
    if(lastYear.isBefore(activities[i].date)){
      //console.log(activities[i].date,activities[i].distance)
      distanceYear = distanceYear + activities[i].distance
    }
  }
  console.log(distanceMonth,lastMonth)
  distanceWeek = distanceWeek/1000
  distanceYear = distanceYear/1000
  distanceMonth = distanceMonth/1000
  return [distanceWeek,distanceMonth,distanceYear]
}

export const durationSum = (activities) => {
    
  activities = Array.from(activities)

  const today = moment()
  const lastMonth = moment().subtract(1, 'month');
  const lastWeek = moment().subtract(1, 'week');
  const lastYear = moment().subtract(1, 'year');

  var distanceMonth = 0
  var distanceWeek = 0
  var distanceYear = 0

  for (var i=0;i<activities.length;i++){
    //
    if(lastMonth.isBefore(activities[i].date)){
      //console.log(activities[i].date,activities[i].distance)
      distanceMonth = distanceMonth + activities[i].duration
    }
    if(lastWeek.isBefore(activities[i].date)){
      //console.log(activities[i].date,activities[i].distance)
      distanceWeek = distanceWeek + activities[i].duration
    }
    if(lastYear.isBefore(activities[i].date)){
      //console.log(activities[i].date,activities[i].distance)
      distanceYear = distanceYear + activities[i].duration
    }
  }
  console.log(distanceMonth,lastMonth)
  distanceWeek = distanceWeek/60
  distanceYear = distanceYear/60
  distanceMonth = distanceMonth/60
  return [distanceWeek,distanceMonth,distanceYear]
}



export function rollingDistance(dates,distance,type){
  if(!rollingDistance.cache){
      rollingDistance.cache = {}
  }
  if(rollingDistance.cache.distance != undefined && rollingDistance.cache.distance!= null){
      if(arraysEqual(distance,rollingDistance.cache.distance) && rollingDistance.cache.type == type){
          return rollingDistance.cache.distance
      }
      
  }
  
  //console.log(rollingDistance.cache)
  const resampleddistance = rollingDistanceOriginal(dates,distance)
  rollingDistance.cache.distance = resampleddistance
  rollingDistance.cache.type = type
  
  return  resampleddistance
  
  
}

export const rollingDistanceOriginal = (dates,distance) =>{
  const rollingDistance = []
  for (var i = 0;i<distance.length;i++){
    const today = moment(dates[i])
    const oneMonthAgo = moment(dates[i]).subtract(31,'day')
    var distanceSum = 0
    for (var j = 0;j<distance.length;j++){
      if (moment(dates[j]).isBetween(oneMonthAgo,moment(dates[i]))){
        distanceSum = distanceSum + distance[j]
      }
    }
    rollingDistance.push(distanceSum)
  }
  return(rollingDistance)
}


export const filter_activities = (activities,filter) =>{
  if (filter === "All"){
    return activities
  }

  var filtered_activities = []
  for (var i=0;i<activities.length;i++){
    if (activities[i].activity_type === filter){
      filtered_activities.push(activities[i])
    }
  }
  return filtered_activities
  
}


export function rollingduration(dates,duration,type){
  if(!rollingduration.cache){
      rollingduration.cache = {}
  }
  if(rollingduration.cache.duration != undefined && rollingduration.cache.duration!= null){
      if(arraysEqual(duration,rollingduration.cache.duration) && rollingduration.cache.type == type){
          return rollingduration.cache.duration
      }
      
  }
  
  //console.log(rollingduration.cache)
  const resampledduration = rollingdurationOriginal(dates,duration)
  rollingduration.cache.duration = resampledduration
  rollingduration.cache.type = type
  
  return  resampledduration
  
  
}

export const rollingdurationOriginal = (dates,duration=[]) =>{
  const rollingduration = []
  for (var i = 0;i<duration.length;i++){
    const today = moment(dates[i])
    const oneMonthAgo = moment(dates[i]).subtract(31,'day')
    var durationSum = 0
    for (var j = 0;j<duration.length;j++){
      if (moment(dates[j]).isBetween(oneMonthAgo,moment(dates[i]))){
        durationSum = durationSum + duration[j]
      }
    }
    rollingduration.push(durationSum)
  }
  return(rollingduration)
}




function arraysEqual(a,b){
  if (String(a) == String(b)){
      return true
  }
  else{
      return false
  }
}